import { InjectionToken } from '@angular/core';
import { AuthTokenConfig } from '../models';

export const AUTH_TOKEN_CONFIG = new InjectionToken<AuthTokenConfig>('authTokenConfig');
